import React from "react";

import { t } from "../../i18n";

import type { UserPreferences } from "../../userPreferences";

interface AppearanceSettingsProps {
  preferences: UserPreferences;
  onChange: (updates: Partial<UserPreferences>) => void;
}

export const AppearanceSettings: React.FC<AppearanceSettingsProps> = ({
  preferences,
  onChange,
}) => {
  return (
    <div className="AppearanceSettings">
      <h3>{t("settings.appearance")}</h3>
      <div className="AppearanceSettings__section">
        <label>{t("settings.theme")}</label>
        <div className="AppearanceSettings__theme">
          <label>
            <input
              type="radio"
              name="theme"
              value="light"
              checked={preferences.theme === "light"}
              onChange={(e) =>
                onChange({ theme: e.target.value as "light" | "dark" })
              }
            />
            {t("buttons.lightMode")}
          </label>
          <label>
            <input
              type="radio"
              name="theme"
              value="dark"
              checked={preferences.theme === "dark"}
              onChange={(e) =>
                onChange({ theme: e.target.value as "light" | "dark" })
              }
            />
            {t("buttons.darkMode")}
          </label>
        </div>
      </div>
      <div className="AppearanceSettings__section">
        <label>{t("settings.canvasBackground")}</label>
        <div className="AppearanceSettings__color">
          <input
            type="color"
            value={preferences.canvasBackground || "#ffffff"}
            onChange={(e) => onChange({ canvasBackground: e.target.value })}
          />
          <input
            type="text"
            value={preferences.canvasBackground || "#ffffff"}
            onChange={(e) => onChange({ canvasBackground: e.target.value })}
          />
        </div>
      </div>
    </div>
  );
};
